import { render, staticRenderFns } from "./ForumWysiwygWithUploader.vue?vue&type=template&id=66342b9c"
import script from "./ForumWysiwygWithUploader.vue?vue&type=script&lang=ts"
export * from "./ForumWysiwygWithUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports